import AJAXLoader from './AJAXLoader';

/**
 * @class
 * @inheritDoc
 * @extends module:media.module:loaders.AJAXLoader
 * @memberof module:media.module:loaders
 * @classdesc Загрузчик XML
 */
class XMLLoader extends AJAXLoader {
    constructor(src) {
        super(src, 'xml');
    }
}

export default XMLLoader;